import React, { memo, useState } from 'react'



import { FormatDate } from '../../components/Format'

import * as queryString from 'query-string'

import { Flex, Box } from '../../components/FlexBox'
import Text from '../../components/Text'
import Modal from '../../components/StyledModal'
import { CloseIcon } from '../../components/Icons'
import CircularProgress from '../../components/CircularProgress'

import { useQuery, useMutation } from '../../hooks/useApollo'
import { GET, FAVORITE } from './Gqls'

import BASE_API from '../../constants/baseApi'
import AUTH_TOKEN from '../../constants/authToken'


const Show = memo(({ patient, navigate }) => {

  const [planImageUrl, setPlanImageUrl] = useState('')

  return (
    <>
      <Box cursor='pointer' onClick={() => navigate(`/pacientes`)}>← Voltar</Box>

      <Flex fd={'column'} p={[2, 3]} ai={'center'}>

        <Flex maxWidth='1000px' p={5} jc={'space-evenly'} ai={'center'} fw={'wrap'} width={[1]}>
          <Flex fd='column' ai='center'>          
            <Box width={100} height={100} overflow='hidden' borderRadius='50%' jc={'center'} border={'3px solid #eee'}>              
              <img style={{width: '100%'}} src={patient.thumbnail} alt='' />
            </Box>
            <Box mt={2} fontSize={3} textAlign='center' maxWidth='200px'>
              {patient.name}
            </Box>          
          </Flex>        
        </Flex>

        <Flex jc='space-between'>
          <Box mx={2}><Text underline pointer onClick={() => navigate(`/pacientes/${patient.id}/exames`)}>Exames</Text></Box>
          <Box mx={2}><Text underline pointer onClick={() => navigate(`/pacientes/${patient.id}/observacoes`)}>Histórico de Observações</Text></Box>
          {patient.healthInsuranceCardPhoto &&
            <Box mx={2}><Text underline pointer onClick={() => setPlanImageUrl(patient.healthInsuranceCardPhoto)}>Ver Carteira do Plano de Saúde</Text></Box>
          }
        </Flex>


        <Flex jc='space-between' p={3} maxWidth='800px' width={1} fw='wrap'>

          <Flex p={3} width={[1, 1, 1, '45%']} fd='column' mt={[3, 3, 3, 0]} border={'1px solid #e1e1e1'} borderRadius={'8px'} boxShadow={'1px 1px 5px rgba(50, 50, 50, 0.15)'}>
            <Flex jc='space-between'>
              <Box><Text fw={700}>Estilo de Vida</Text></Box>
            </Flex>
            <Box fontSize={2}>
              <Box mt={2}><Text>Alimentação:</Text> {patient.alimentation && patient.alimentation.name}</Box>
              <Box mt={1}><Text>Alcool :</Text> {patient.alcohol && patient.alcohol.name}</Box>
              <Box mt={1}><Text>Cigarro :</Text> {patient.smoke && patient.smoke.name}</Box>
              <Box mt={1}><Text>Drogas :</Text> {patient.drug && patient.drug.name}</Box>
              <Box mt={1}><Text>Atividades Físicas :</Text> {patient.physicalActivity && patient.physicalActivity.name}</Box>
            </Box>          
          </Flex>

          <Flex p={3} fontSize={2} width={[1, 1, 1, '45%']} fd='column' mt={[3, 3, 3, 0]} height={'auto'} border={'1px solid #e1e1e1'} borderRadius={'8px'} boxShadow={'1px 1px 5px rgba(50, 50, 50, 0.15)'}>
            <Flex jc='space-between'>
              <Box><Text fw={700}>Alergias</Text></Box>
            </Flex>
            <Box mb={3}>
              {patient.allergies.map(item => item.name).join(', ')}
            </Box>

            <Flex jc='space-between'>
              <Box><Text fw={700}>Histórico Familiar</Text></Box>
            </Flex>
            <Box mb={3}>
              {patient.familyHistory.map(item => item.name).join(', ')}
            </Box>

            <Flex jc='space-between'>
              <Box><Text fw={700}>Medicamentos contínuos</Text></Box>
            </Flex>
            <Box mb={3}>
              {patient.continuousMedications.map(item => item.name).join(', ')}
            </Box>

          </Flex>
        </Flex>

        <Flex jc='space-between' p={3} maxWidth='800px' width={1} fw='wrap'>          
          <Flex fd='column' p={3} fontSize={2} width={[1, 1, 1, '45%']} mt={[3, 3, 3, 0]} border={'1px solid #e1e1e1'} borderRadius={'8px'} boxShadow={'1px 1px 5px rgba(50, 50, 50, 0.15)'}>

            <Flex jc='space-between'>
              <Box><Text fw={700}>Informações</Text></Box>
            </Flex>

              <Box mt={1}><Text strong>Nome:</Text> {patient.name}</Box>
              <Box mt={1}><Text strong>Data de Nascimento: </Text><FormatDate>{patient.birthDate}</FormatDate></Box>
              <Box mt={1}><Text strong>CPF: </Text>{patient.cpf}</Box>
              <Box mt={1}><Text strong>Gênero: </Text>{patient.gender}</Box>
              <Box mt={1}><Text strong>Número de celular: </Text>{patient.cellphone}</Box>
              <Box mt={1}><Text strong>Email: </Text>{patient.login}</Box>
            </Flex>
            <Flex fd='column' p={3} fontSize={2} width={[1, 1, 1, '45%']} mt={[3, 3, 3, 0]} border={'1px solid #e1e1e1'} borderRadius={'8px'} boxShadow={'1px 1px 5px rgba(50, 50, 50, 0.15)'}>
            
              <Flex jc='space-between'>
                <Box><Text fw={700}>Plano de Saúde</Text></Box>
              </Flex>
            
              <Box><Text strong>Plano de Saúde: </Text>{patient.healthInsuranceSubPlan ? patient.healthInsuranceSubPlan.name : ''}</Box>
              <Box><Text strong>Número do cartão: </Text>{patient.healthInsuranceNumber}</Box>
              {/* <Box><Text strong>Tipo: </Text>{patient.name}</Box> */}

              
            </Flex>
        </Flex>

      </Flex>

      {planImageUrl &&
        <Modal
          onCloseCompleted={() => { setPlanImageUrl('') }}
          render={
            ({onRequestClose}) => (
              <Flex fd='column' h='100%'>
                <Box position='relative' h={64}>
                  <Box position='absolute' cursor='pointer' lh='0' top={16} right={16} onClick={onRequestClose}><CloseIcon /></Box>
                  <Box p={3} ta='center'><Text secondary large>Carteira do Plano</Text></Box>
                </Box>
                <Box p={4} overflow='auto'>
                  <Box>
                    <img src={planImageUrl} style={{width: '100%'}} />
                  </Box>
                </Box>
              </Flex>
            )
          }
        />
      }

    </>
  )
})

export default memo(props => {
  const { data, error, loading } = useQuery(GET, { variables: { id: props.id } })
  if (error) return `Erro! ${error.message}`
  if (!data || loading) return <CircularProgress />
  console.log('data.patient', data.patient)
  return <Show {...props} patient={data.patient} me={data.me} />
})
